/*-------------------------------------------*\
    custom.js

    Index
    1.0 - General
    2.0 - MISC
    3.0 - Infinity Slider
    4.0 - Highlights
        4.1 - Add • Between Highlights
    5.0 - Highlights With Image
        5.1 - Add • Between Highlights With Image
    6.0 - Before And After
    7.0 - Review Carousel
    8.0 - Tablify
    9.0 - Slider Comparison
    10.0 - Product Questions
    11.0 - Sticky ATC
    12.0 - FAQ
    13.0 - Announcement Bar
\*-------------------------------------------*/

jQuery(document).ready(function($) {

  /*-------------------------------------------*\
   7.0 - Review Carousel
\*-------------------------------------------*/
  $(".review-carousel__slider").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
$(".iconslideshow").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
           dots: true,
          
        },
      },
    ],
  });
 
});

